import swal from "sweetalert2";

var topnavbar;

import AdminApi from '../../services/api'
import session from "../../services/session";

const AdminApiService = new AdminApi()

export default {
    computed: {
        routeName() {
            const {name} = this.$route
            return this.capitalizeFirstLetter(name)
        }
    },

    data() {
        return {
            repeatSchedule : 1800000,
            username: '',
            payment: '',
            paymentStyle : '',
            numberOfNewOrders: 0,
            numberOfNewVacations: 0,
            activeNotifications: false,
            changePasswordModalVisible: false,
            restOfTraining: 0,
            isOrderSelected: false,
            calledFunc: null,
            calledFuncSchedule: null,
        }
    },

    mounted() {
        this.getAllData();
        this.checkSchedule();
    },

    beforeMount() {
        topnavbar = this;
        this.getUsername();
    },
    beforeDestroy() {
        if(this.calledFunc != null){
            clearTimeout(this.calledFunc);
            this.calledFunc = null;
        }
        if(this.calledFuncSchedule != null){
            clearTimeout(this.calledFuncSchedule);
            this.calledFuncSchedule = null;
        }
    },

    created() {
        var self = this;
        this.$tabEvent.on('onNewOrder', (data) => {
            self.username = 'test'
        });

        this.$topnavbar.$on('onGetVacation', (data) => {
            self.numberOfNewVacations = data
        });



        this.$topnavbar.$on('load', () => {
            swal({
                title: "",
                text: "",
                type: "",
                // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
                html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
                showCancelButton: false,
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                customClass: 'swal-custom'
            }, function (selection) {

            });
        });

        this.$topnavbar.$on('cancelTrainings', () => {
            swal({
                title: "",
                text: "",
                type: "",
                // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
                html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Otkazivanje treninga...</div>",
                showCancelButton: false,
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                customClass: 'swal-custom'
            }, function (selection) {

            });
        });
    },

    methods: {
        getAllData: getAllData,
        getOrders: getOrders,
        checkSchedule: checkSchedule,
        isEnableForUsernames: isEnableForUsernames,
        getVacationsRequested: getVacationsRequested,
        getUsername(){

            this.username =  localStorage.getItem("USERNAME");
        },
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },

        toggleSidebar() {
            this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
        },
        hideSidebar() {
            this.$sidebar.displaySidebar(false);
        },
        signOut() {
            this.isOrderSelected = false;
            this.$router.push('/login');
            this.$sessionService.destroyUser();
        },
        home() {
            this.isOrderSelected = false;
            this.$router.push('/home');
        },

        customers() {
            this.isOrderSelected = false;
            this.$router.push('/customers');
        },

        orders() {
            this.isOrderSelected = true;
            this.numberOfNewOrders = 0;
            this.$router.push('/orders');
        },

        testAI() {
            this.isOrderSelected = false;
            this.$router.push('/test-ai');
        },

        maps() {
            this.isOrderSelected = false;
            this.$router.push('/maps');
        },
        drivers() {
            this.isOrderSelected = false;
            this.$router.push('/drivers');
        },
        dispatchers() {
            this.isOrderSelected = false;
            this.$router.push('/dispatchers');
        },

        companies() {
            this.isOrderSelected = false;
            this.$router.push('/companies');
        },

        schedule() {
            this.isOrderSelected = false;
            this.$router.push('/schedule');
        },

        reportSchedule() {
            this.isOrderSelected = false;
            this.$router.push('/report-schedule');
        },
        price() {
            this.isOrderSelected = false;
            this.$router.push('/price-list');
        },

        vehicle() {
            this.isOrderSelected = false;
            this.$router.push('/vehicle');
        },

        orderReport() {
            this.isOrderSelected = false;
            this.$router.push('/order-report');
        },

        averageReport() {
            this.isOrderSelected = false;
            this.$router.push('/average-report');
        },

        vehicleReport() {
            this.isOrderSelected = false;
            this.$router.push('/vehicle-report');
        },
        configuration() {
            this.isOrderSelected = false;
            this.$router.push('/configuration');
        },
        rateAndBugs() {
            this.isOrderSelected = false;
            this.$router.push('/rate-and-bugs');
        },

        profile() {
            this.isOrderSelected = false;
            this.$router.push('/profile');
        },

    }
}

function checkSchedule() {
    let _self = this;
    _self.getVacationsRequested();
    if(_self.calledFuncSchedule != null){
        clearTimeout(_self.calledFuncSchedule);
    }

    _self.calledFuncSchedule = setTimeout(function(){ _self.checkSchedule(); }, _self.repeatSchedule);
}
function getAllData() {
    let _self = this;
    if(window.location.href.includes("orders") === false){
        _self.getOrders();
    }
    if(_self.calledFunc != null){
        clearTimeout(_self.calledFunc);
    }
    _self.calledFunc = setTimeout(function(){ _self.getAllData(); }, 10000);
}

function getOrders() {
    var _self = this;
    var calendarTimestamp = Date.now();

    var activeParams = "?status=REQUESTED";
    var timestamp = "&timestamp=" + calendarTimestamp;
    AdminApiService.getOrders(activeParams, timestamp)
        .then((response) => {
            var count = response.data.filter(item => item.status === "REQUESTED").length;
            if(count > _self.numberOfNewOrders){
                _self.$toasted.error('Nova porudžbina od lokala',{ position: "top-left", duration: 3000})
            }
            _self.numberOfNewOrders = count;
        }).catch((error) => {
            console.log(error);
        })
}

function getVacationsRequested(){
    let _self = this;
    AdminApiService.getRequestedVacations()
        .then((response) => {
            _self.numberOfNewVacations = response.data.length;
        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function isEnableForUsernames(){
    return session.getUsername() !== 'Sonicsonic2011'
}


// WEBPACK FOOTER //
// ./src/components/Layout/TopNavbar.js